import _ from 'underscore';
import { getOdataPath } from '../get';

function getTrackPayload({
  isAll,
  recommendations,
  recommendationType,
  channel,
  UserAction,
}) {
  const odataType = isAll ? 'ApplyAllOpportunitiesRequest' : 'ApplyBulkOpportunitiesRequest';
  const inputKey = isAll ? 'UserInput' : 'UserInputs';
  const inputValue = isAll ? null : _.map(recommendations, recommend => ({
    OpportunityId: recommend.OpportunityId,
  }));

  return {
    Request: _.extend({}, {
      '@odata.type': `#Microsoft.Advertiser.AdInsight.Opportunity.Core.Adoption.Interface.Entity.${odataType}`,
      'OpportunityType@odata.type': '#Microsoft.Advertiser.AdInsight.Opportunity.Schema.OpportunityType',
      OpportunityType: recommendationType,
      'UserAction@odata.type': '#Microsoft.Advertiser.AdInsight.Opportunity.Core.Adoption.Interface.Entity.UserActionCode',
      UserAction,
      Settings: {
        '@odata.type': '#Microsoft.Advertiser.AdInsight.Opportunity.Core.Adoption.Interface.Entity.ApplySettings',
      },
      [inputKey]: inputValue,
      Channel: channel,
    }, isAll ? null : {
      'UserInputs@odata.type': '#Collection(Microsoft.Advertiser.AdInsight.Opportunity.Core.Adoption.Interface.Entity.ApplyUserInput)',
    }),
  };
}

export function adoptRecommendations({
  deps,
  isAll,
  recommendations,
  recommendationType,
  scope,
  channel,
  UserAction,
}) {
  const action = isAll ? 'TrackAll' : 'Track';
  const uri = `/AdInsight/V2/Customers(${scope.customerId})/Accounts(${scope.accountId})/Opportunity.${action}`;
  return deps.httpUtils.odata.post({
    uri,
    data: getTrackPayload({
      isAll,
      recommendations,
      channel,
      UserAction,
      recommendationType,
    }),
    ...deps.odataOptions,
    host: getOdataPath(deps.odataOptions && deps.odataOptions.host),
  });
}
